(() => {
        const container = document.getElementById('storepoint-container');
        if (!container) return;

        const params = new URLSearchParams(location.search);
        const locationId = params.get('location');
        const latParam = params.get('lat');
        const lngParam = params.get('lng');
        const lat = latParam === null ? NaN : Number(latParam);
        const lng = lngParam === null ? NaN : Number(lngParam);

        const initialState = { auto_detect_location: true, radius: Number(container.dataset.radius) || 55 };
        const testCoordinatesPromise = Promise.resolve(window.RetiqueGeoLocatorOverride?.getCoordinates?.());

        if (Number.isFinite(lat) && Number.isFinite(lng)) {
            initialState.auto_detect_location = false;
            initialState.lat = lat;
            initialState.lng = lng;
        }

        const tags = (container.dataset.tags || '').split(',').map(s => s.trim()).filter(Boolean);

        const Storepoint = window.Storepoint = window.Storepoint || {
            _q: [], on(evt, cb) { this._q.push([evt, cb]); }
        };

        if (tags.length) {
            // Storepoint's setFilters() mirrors the filter state into ?tags=.
            // Wrap history methods so any URL update has `tags` stripped out.
            const stripTags = (url) => {
                if (url == null) return url;
                const u = new URL(url, location.href);
                u.searchParams.delete('tags');
                return u.pathname + (u.search || '') + u.hash;
            };
            const push = history.pushState.bind(history);
            const replace = history.replaceState.bind(history);
            history.pushState = (state, title, url) => push(state, title, stripTags(url));
            history.replaceState = (state, title, url) => replace(state, title, stripTags(url));

            Storepoint.on('load', () => Storepoint.setFilters?.(tags));
        }

        // If a location id was passed, open its detail panel once the widget loads.
        if (locationId) {
            Storepoint.on('load', () => {
                const open = () => {
                    const list = (typeof Storepoint.getCurrentLocations === 'function')
                        ? Storepoint.getCurrentLocations() : [];
                    const target = list.find(l => String(l.id) === String(locationId));
                    const card = target && document.querySelector(`[data-location-id="${target.id}"]`);
                    if (card) card.click();
                };
                // Try once after load, then again on the first search event (list populated).
                setTimeout(open, 300);
                Storepoint.on('search', () => setTimeout(open, 100));
            });
        }

        const script = document.createElement('script');
        script.src = 'https://widget.storepoint.co/embed.js';
        script.async = true;
        script.onload = () => {
            if (typeof window.StorepointWidget !== 'function') return;
            testCoordinatesPromise.then(testCoordinates => {
                window.RetiqueGeoLocatorOverride?.applyStorepointUrlOverride?.(testCoordinates);

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                    if (Number.isFinite(testCoordinates?.latitude) && Number.isFinite(testCoordinates?.longitude)) {
                        initialState.auto_detect_location = false;
                        initialState.lat = testCoordinates.latitude;
                        initialState.lng = testCoordinates.longitude;
                        initialState.search_text = window.RetiqueGeoLocatorOverride?.testZipcode || undefined;
                    }
                }

                new window.StorepointWidget(container.dataset.widgetId, '#' + container.id, { initialState });
            });
        };
        document.head.appendChild(script);
    })();
